import { useNavigate } from "react-router-dom";
import { ArrowRight, Building2, HardHat, Route, Sparkles } from "lucide-react";
import { FOUNDER } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

const ICONS = { Building2, HardHat, Route, Sparkles };

// Transforme **mot** en <strong>.
const Rich = ({ text }) =>
  text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
    i % 2 === 1 ? (
      <strong key={i} className="font-medium text-cream">
        {part}
      </strong>
    ) : (
      part
    )
  );

export const Founder = () => {
  const navigate = useNavigate();
  return (
    <section id="fondatrice" className="scroll-mt-20 border-y border-white/10 bg-[#1D1327]" data-testid="section-fondatrice">
      <div className="grid lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden sm:aspect-[16/10] lg:sticky lg:top-[72px] lg:aspect-auto lg:h-[calc(100vh-72px)]">
            <img
              src={FOUNDER.photo}
              alt={FOUNDER.photoAlt}
              data-testid="fondatrice-photo"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1D1327] via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-[#1D1327]" />
          </div>
        </div>

        <div className="px-6 py-16 sm:px-10 lg:col-span-7 lg:px-16 lg:py-28 xl:pr-24">
          <Reveal>
            <Eyebrow>{FOUNDER.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl" data-testid="fondatrice-title">
              {FOUNDER.title}
            </h2>
          </Reveal>

          <div className="mt-10 space-y-5 text-base leading-relaxed text-white/60 sm:text-lg" data-testid="fondatrice-texte">
            {FOUNDER.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.04}>
                <p>
                  <Rich text={p} />
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <blockquote className="mt-12 border-l-2 border-neon pl-6 sm:pl-8" data-testid="fondatrice-citation">
              <p className="font-serif text-2xl italic leading-snug text-neon-light sm:text-3xl">« {FOUNDER.quote} »</p>
              <footer className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">Élise — fondatrice</footer>
            </blockquote>
          </Reveal>

          <div className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="fondatrice-blocs">
            {FOUNDER.blocks.map((b, i) => {
              const Icon = ICONS[b.icon];
              return (
                <Reveal key={b.label} delay={0.1 + i * 0.06} className="h-full">
                  <div className="group flex h-full flex-col gap-4 border border-white/10 bg-white/[0.03] p-5 transition-colors duration-300 hover:border-neon/60" data-testid={`fondatrice-bloc-${b.label.toLowerCase()}`}>
                    <span className="grid h-10 w-10 place-items-center border border-neon/40 text-neon transition-colors group-hover:bg-neon group-hover:text-ink">
                      <Icon className="h-4 w-4" />
                    </span>
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">{b.label}</p>
                      <p className="mt-1.5 text-sm leading-snug text-cream">{b.value}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.2}>
            <button onClick={() => navigate("/rendez-vous")} data-testid="fondatrice-cta" className="btn-primary mt-12">
              {FOUNDER.cta} <ArrowRight className="h-4 w-4" />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
